import i18n from '../i18n/i18n';

/**
 * Creates a language-prefixed link for a given path
 * @param path The path without language prefix
 * @param lang Optional language code, defaults to current language
 * @returns Language-prefixed path
 */
export const getLocalizedPath = (path: string, lang?: string): string => {
  // If path already starts with a language code, remove it
  const cleanPath = path.replace(/^\/*(en|fr|ar)\/+/, '');
  
  // Use specified language or current language from i18n
  const language = lang || i18n.language.split('-')[0];
  
  // Build the localized path
  return `/${language}/${cleanPath.replace(/^\/+/, '')}`;
};

/**
 * Creates a localized external URL for the site
 * @param path The path without language prefix
 * @param lang Optional language code, defaults to current language
 * @returns Full URL with language prefix
 */
export const getLocalizedUrl = (path: string, lang?: string): string => {
  const baseDomain = window.location.origin;
  const localizedPath = getLocalizedPath(path, lang);
  return `${baseDomain}${localizedPath}`;
};

/**
 * Creates a localized absolute URL with the current host
 * @param path The path without language prefix 
 * @returns Full URL with language prefix and host
 */
export const getAbsoluteUrl = (path: string): string => {
  const host = window.location.origin;
  const localizedPath = getLocalizedPath(path);
  return `${host}${localizedPath}`;
}; 